import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { AlertCircle, RefreshCw } from 'lucide-react'

interface ErrorStateProps {
	onRetry: () => void
}

export function ErrorState({ onRetry }: ErrorStateProps) {
	return (
		<div
			className="page-container"
			data-test-id="launch-config-page-container"
		>
			<div className="page-inner" data-test-id="launch-config-page-inner">
				<Card className="p-6" data-test-id="no-config-card">
					<div className="text-center">
						<AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
						<h3 className="text-lg font-semibold mb-2">
							No Configuration Found
						</h3>
						<p className="text-gray-600">
							Launch configuration could not be loaded.
						</p>
						<Button
							onClick={onRetry}
							className="mt-4"
							data-test-id="retry-load-button"
						>
							<RefreshCw className="h-4 w-4 mr-2" />
							Retry
						</Button>
					</div>
				</Card>
			</div>
		</div>
	)
}

